module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-af-download-logo-blue.77ab8f28253ca4bd15093723095eba51.svg";